	var $ = require('@alife/alpha-jquery/jquery'),
		Core = require('./src/js/arale-validator/core'),
		i18n = require('./src/i18n'),

		errorTracker = require('./src/js/error-tracker'),

		uuid = 0,

		CACHE_ERROR_ID = '_validator-error-id',
		MESSAGE_ID_SUFFIX = '-validator-error',

		SERVER_ERRORMESSAGE = 'data-server-errormessage',
		CFG_SERVER_ERRORMESSAGE = 'serverErrormessage';

	// 实例的缓存
	var incs = [];

	// add custom rules.
	require('./src/js/rules');

	var Validator = Core.extend({

		_errorItems: null,
		_formValidateStart: false,

		attrs: {

			autoFocus: true,
			/**
			 字段控件的包装，getItem获得的是该选择器的DOM
			 控件就近的父级DOM
			*/
			itemSelector: '.ui2-form-control', // 字段包裹
			itemErrorClass: '', // dpl未定义字段错误
			/**
			 自定义的select，检验时仍然校验的原生select，
			 但是，错误样式要添加到自定义的结构上，
			 提供inputSelector便于定制
			*/
			inputSelector: '', // 用于添加inputErrorClass的控件，如select，结果和展示是两个结构，错误需显示在展示的结构上
			inputErrorClass: 'ui2-form-error', // 控件错误标记，加边框
			/**
			 指定出错信息的DOM结构插入到哪个DOM中
			 直接指定对应的DOM
			*/
			errorParent: null, // 错误信息展示的父容器
			/**
			 指定出错信息的DOM结构插入到哪个DOM中
			 使用相对于addItem时的element查找就近的父级DOM
			*/
			errorParentSelector: '.ui2-form-control', // 错误信息展示的父容器 选择器
			errorContentSelector: '[data-role="content"]', // 错误信息填入的容器 选择器
			errorTpl: '<div class="ui2-feedback ui2-feedback-input-error"><div data-role="content" class="ui2-feedback-title"></div></div>',

			showMessage: function(message, element) {
				var item = this.query(element);
				if( item === undefined ){
					return;
				}

				this._setErrorMessage(element, message).show();

				var itemErrorClass = item.get('itemErrorClass') || this.get('itemErrorClass');
				var $control = this.getItem(element);
				$control.addClass(itemErrorClass);

				var ele = element;
				if ($(element).attr('type') != 'radio' && $(element).attr('type') != 'checkbox') {
					var inputErrorClass = item.get('inputErrorClass') || this.get('inputErrorClass');
					ele = getInputElement($control, item, this, element);
					$(ele).addClass(inputErrorClass);
				}

				// 渲染错误之后触发事件
				this.trigger('showMessage', {
					element: element,
					input: ele,
					errorElement: this.getError(element)
				});

			},

			hideMessage: function(message, element) {
				var validateItem = this.query(element);
				if( validateItem === undefined ){
					return;
				}
				var item = this.query(element),
				inputErrorClass = validateItem.get('inputErrorClass') || this.get('inputErrorClass'),
				errorElement = this.getError(element);
				var $control = this.getItem(element);

				if (errorElement) {
					errorElement.hide();
				}

				//去除输入控件的标红样式
				if ($(element).attr('type') != 'radio' && $(element).attr('type') != 'checkbox') {
					var ele = getInputElement($control, item, this, element);
					$(ele).removeClass(inputErrorClass);
				}

				//如果整行元素没有出错情况则去除整行的出错样式，这主要是为了兼容一行内有多个输入控件的情况
				if ($control.find('.' + inputErrorClass).length == 0) {
					var itemErrorClass = validateItem.get('itemErrorClass') || this.get('itemErrorClass');
					$control.removeClass(itemErrorClass);
				}

			}
		},

		// override
		setup: function(){
			Validator.superclass.setup.call(this);

			// 缓存实例
			incs.push(this);
			errorTracker.bindEvents(Validator, this);
		},

		// override
		destroy: function(){
			for(var i = 0, l = incs.length; i < l; i++){
				if(this === incs[i]){
					break;
				}
			}

			// 删除缓存
			if(i != l){
				incs.splice(i, 1);
			}


			Validator.superclass.destroy.call(this);
		},

		addItem: function(cfg) {
			var tcfg = (!$.isArray(cfg) ? [cfg] : cfg);
			var ele, serverErrorMessage;

			Validator.superclass.addItem.call(this, cfg);

			for (var i = 0, ln = tcfg.length; i < ln; i++) {
				ele = $(tcfg[i].element);

				if (tcfg[i][CFG_SERVER_ERRORMESSAGE]) {
					serverErrorMessage = tcfg[i][CFG_SERVER_ERRORMESSAGE];
				} else {
					serverErrorMessage = ele.attr(SERVER_ERRORMESSAGE);
				}

				if (serverErrorMessage) {
					this.showMessage(serverErrorMessage, ele);
					this.trigger('serverErrormessage', ele, serverErrorMessage);
				}

			}
			return this;
		},

		showMessage: function(message, element) {
			this.get('showMessage').call(this, message, element);
		},

		hideMessage: function(message, element) {
			this.get('hideMessage').call(this, message, element);
		},

		getError: function(ele) {
			var errorId = this.getErrorId(ele);
			var error = $('#' + errorId);

			return error.length ? error: null;
		},

		_renderError: function(ele) {
			// item 增加parent定义，便于控件嵌套
			var item = this.query(ele);
			var errorTpl = item.get('errorTpl') || this.get('errorTpl');
			var error = $(errorTpl),
			errorParentSelector = item.get('errorParentSelector') || this.get('errorParentSelector') || this.get('itemSelector'),
			errorParent = $(item.get('errorParent') || this.get('errorParent'));

			if(!errorParent.length){
				errorParent = ele.closest(errorParentSelector).first();
			}
			if (!errorParent.length) {
				errorParent = this.getItem(ele);
			}

			error.prop('id', this.getErrorId(ele)).hide().appendTo(errorParent);

			return error;
		},

		_setErrorMessage: function(ele, message) {
			var item = this.query(ele);
			var errorElement = this.getError(ele),
			contentSelector,
			content;

			if (!errorElement) {
				errorElement = this._renderError(ele);
			}

			contentSelector = item.get('errorContentSelector') || this.get('errorContentSelector');
			content = errorElement.find(contentSelector);

			if (!content.length) {
				content = errorElement;
			}

			content.html(message);

			return errorElement;
		},

		getErrorId: function(ele) {
      ele = $(ele);
			if (ele.data(CACHE_ERROR_ID)) {
				return ele.data(CACHE_ERROR_ID);
			}

			var id = ele.prop('id');

			// 返回 eleId-validator-message 或者 _validator_auto-validator-message
			id = (id ? id: this._uuid()) + MESSAGE_ID_SUFFIX;

			//把生成的错误容器的id缓存到输入框的数据里
			ele.data(CACHE_ERROR_ID, id);

			return id;

		},

		_uuid: function() {
			++uuid;
			return '_validator_auto' + uuid;
		},

		getItem: function(ele) {
			var item = this.query(ele);
			var selector = (item && item.get && item.get('itemSelector')) || this.get('itemSelector');
			item = $(ele).closest(selector);

			return item;
		}
	});

	Validator.setMessage(i18n);

	// 获取展示元素
	function getInputElement(control, item, validator, element){
		var ele = item.get('inputSelector') || validator.get('inputSelector') || element;
		if(!$.isPlainObject(ele)){
			ele = control.find(ele);
		}
		return ele;
	}

	// 引入
	errorTracker.init(Validator, incs);

	module.exports = Validator;
